import { Instagram, Twitter, Youtube, Facebook } from "lucide-react";

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-void-black border-t border-white/5 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Logo & Tagline */}
          <div className="md:col-span-2">
            <div className="font-graffiti text-3xl mb-4">
              <span className="neon-text-blue">GRIND</span>
              <span className="neon-text-pink">TIME</span>
            </div>
            <p className="font-rajdhani text-gray-500 max-w-sm">
              Elite football training for athletes who refuse to settle. Transform your game. Dominate the field.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center border border-white/10 text-gray-500 hover:text-neon-blue hover:border-neon-blue transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center border border-white/10 text-gray-500 hover:text-neon-blue hover:border-neon-blue transition-colors"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center border border-white/10 text-gray-500 hover:text-neon-pink hover:border-neon-pink transition-colors"
                data-testid="social-youtube"
              >
                <Youtube className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center border border-white/10 text-gray-500 hover:text-neon-blue hover:border-neon-blue transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-orbitron text-sm text-white mb-4 uppercase">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { id: 'roster', label: 'Roster' },
                { id: 'pricing', label: 'Pricing' },
                { id: 'media', label: 'Media' },
                { id: 'schedule', label: 'Schedule' },
              ].map(link => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="font-rajdhani text-gray-500 hover:text-neon-blue transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="font-orbitron text-sm text-white mb-4 uppercase">More</h4>
            <ul className="space-y-2">
              {[
                { id: 'shop', label: 'Shop' },
                { id: 'community', label: 'Community' },
                { id: 'about', label: 'About' },
              ].map(link => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="font-rajdhani text-gray-500 hover:text-neon-pink transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-rajdhani text-sm text-gray-600">
            © {new Date().getFullYear()} GRIND TIME. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="font-rajdhani text-xs text-gray-600 hover:text-gray-400 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="font-rajdhani text-xs text-gray-600 hover:text-gray-400 transition-colors">
              Terms of Service
            </a>
            <a href="#" className="font-rajdhani text-xs text-gray-600 hover:text-gray-400 transition-colors">
              Refund Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
